import { Collection, HandlersCollection } from "@tblabs/truffle";
import { Cost, Discount } from "./Discount";
import { BasketConfig } from "./BasketConfig";
import { DiscountType } from "./RawCost";


export class Discounter
{
    public Discounts = new Collection<Discount>();
    // public Extras = new Collection<ExtraCost>();

    constructor(private _basketConfig: BasketConfig)
    {
        const predefinedDiscounts = _basketConfig.Discounts.Items;
        // const predefinedExtras = _basketConfig.Extras.Items;

        predefinedDiscounts.filter(x => x.IsVisible.value).forEach(discount => this.AddDiscount(discount));
        // predefinedExtras.filter(x => x.IsVisible.value).forEach(extra => this.AddExtra(extra));

        this.Discounts.OnChange(list =>
        {
            this.onChange.Call();
        });
        // this.Extras.OnChange(list =>
        // {
        //     this.onChange.Call();
        // });
    }

    public GetActiveCosts(): Cost[]
    {
        const discounts = this.Discounts.Items.filter(x => x.IsOn.IsTrue());
        // const extras = this.Extras.Items.filter(x => x.IsOn.IsTrue());

        // return [...discounts, ...extras];
        return [...discounts];
    }

    public Has(discount: Discount): boolean
    {
        return this.Discounts.Find(x => x.Code.value == discount.Code.value) !== undefined;
    }

    public IsOn(code: string): boolean
    {
        return this.Discounts.Items.some(x => x.Code.value == code && x.IsOn.IsTrue());
    }

    public Remove(discount: Discount): void
    {
        this.Discounts.Remove(discount);
    }

    public AddDiscount(discount: Discount): void
    {
        if (!this.Has(discount))
        {
            discount.IsOn.OnChange(v => this.onChange.Call());

            this.Discounts.Add(discount);
        }
    }

    // public AddExtra(extra: ExtraCost): void
    // {
    //     if (!this.Has(extra))
    //     {
    //         extra.IsOn.OnChange(v => this.onChange.Call());

    //         this.Extras.Add(extra);
    //     }
    // }

    public FindByCode(code: string): Discount | null
    {
        const sanitizedCode = code.trim().toUpperCase();

        const discount = this._basketConfig.Discounts.Find(x => x.Code.value.toUpperCase() == sanitizedCode);

        return discount || null;
    }

    // public GetTotalPercent(): number
    // {
    //     const discountsTotalPercent = this.Discounts.Items
    //         .filter(x => x.IsOn.value)
    //         .reduce((prev, cur) => {
    //             if (cur.Type.value == DiscountType.Percent)
    //             {
    //                 return prev + cur.Value.value;
    //             }
    //             else if (cur.Type.value == DiscountType.LimitedPercent)
    //             {
    //                 const limit
    //                 return prev + cur.Value.value;
    //             }
    //             return prev;
    //             return prev + cur.Value.value;
    //         }, 0);

    //     if (discountsTotalPercent > 100)
    //         return 100;

    //     return discountsTotalPercent;
    // }
    public GetTotalValue(price: number): number
    {
        const totalValue = this.Discounts
            .Filter(x => x.IsOn.IsTrue())
            .reduce((prev, cur) => prev + cur.CalcValue(price), 0);

        return totalValue;
    }

    private onChange = new HandlersCollection<() => void>();
    public OnChange(handler: () => void)
    {
        this.onChange.Add(handler);
    }
}
